
export interface FundsRequestDataForm {
    id?: number;
    start_date?: Date | string;
    date: Date | string;
    state?: boolean;
    worker?: Worker;
    worker_id?: number;
    currency_id?: number;
    currency?: string;
    worker_name?: string;
    end_date?: Date | string;
    request_reason?: string;
    request_reason_id?: number;
    request_reason_name?: string;
    transfer_reason?: string;
    transfer_reason_id?: number;
    is_approved?: boolean;
    total?: number | string;
    worker_total?: WorkerTotal[];
    created_user?: string;
    status?: string
    next_status_options?: FundRequestStatus[]
    society_id?: number;
    society?: string | null;
}

export interface WorkerTotal {
    worker_id?: number | string;
    total: number | string;
    currency_id?: number | string;
    transfer_reason?: string;
    transfer_reason_id?: number;
}

export interface FundRequestReason {
    value: number | string;
    label: number | string;
}

export interface FundRequestStatus {
    id?: number | string;
    name?: number | string;
    label?: number | string;
    status?: number | string;
    issue_date?: string;
    society_bank_account_id?: number;
    society_id?: number;
    society?: string;
}

export const defaultFundRequestStatus: FundRequestStatus = {
    id: '',
    name: '',
    label: '',
    status: '',
    issue_date: '',
    society_bank_account_id: undefined,
    society_id: undefined,
    society: undefined
};

export const defaultWorkerTotal: WorkerTotal = {
        worker_id: -1,
        total: 0,
        currency_id: 1
    };

export const defaultFundsRequestDataForm: FundsRequestDataForm = {
    date: '',
    worker_id: undefined,
    worker_total: [defaultWorkerTotal]
};

export interface FundsFilters{
    id?: number | null;
    name?: string | '';
    carrier?: string | null;
    is_active?: boolean | '';
    date?: string | '';
    start_date?: string | '';
    end_date?: string | '';
    transfer_reason?: string | '';
    created_user?: string | '';
    status?: string | null | '';
    worker_id?: number;
    society_id?: number;
    society?: string | null;
    
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export interface MassiveStatusForm {
    status?: string;
    all_selected?: boolean;
    selected_count?: number;
    rows_ids?: number[];
    issue_date?: string;
    society_bank_account_id?: number;
}